import * as React from "react";
import { Navigate } from "@opendash/router";

// B leitet direkt zu B.1 (Wie funktioniert ein Wasserwerk?) weiter
export const WasseraufbereitungRoute = React.memo(
  function WasseraufbereitungRoute() {
    return (
      <Navigate to="/wasserklaerer/wasseraufbereitung/wasserwerk" replace />
    );
  }
);
